// RPilot availability whitelist.
//
// The RPilot menu buttons and the /rpilot + /taskset-profiles/rpilot routes are
// only shown when the app's `apiUrl` (from the embed query string) matches one
// of these hosts. Add a host here to enable RPilot for that environment.
export const RPILOT_ALLOWED_API_HOSTS = [
  'api-mena-mcp.rdrive.io',
  'api-baj.rdrive.io',
  'api-baj-mcp.rdrive.io',
  'api-baj-test.rdrive.io',
  'api-qa.rdrive.io',
  'api-hk.rdrive.io',
  'api-mena-bim.rdrive.io',
  'api-pixijs-taskviewer-poc.rdrive.io'
];

/**
 * Reduce an apiUrl value (bare host, or a URL with scheme/port/path) to a
 * lowercase hostname so it can be compared against the whitelist.
 */
export function normalizeApiHost(apiUrl) {
  if (typeof apiUrl !== 'string') return '';
  let value = apiUrl.trim().toLowerCase();
  if (!value) return '';
  value = value.replace(/^[a-z][a-z0-9+.-]*:\/\//, ''); // scheme
  value = value.split(/[/?#]/)[0]; // path / query / hash
  value = value.replace(/^[^@]*@/, ''); // credentials
  value = value.replace(/:\d+$/, ''); // port
  return value;
}

export function isRPilotEnabledForApiUrl(apiUrl, allowedHosts = RPILOT_ALLOWED_API_HOSTS) {
  const host = normalizeApiHost(apiUrl);
  return Boolean(host) && allowedHosts.includes(host);
}
